// Returns the date object indicating the time when the current node was opened for editing.
export default function getOpenedForEditingAt(state) {
  return state.editor?.openedForEditingAt
}
